/**
 * Sumário das páginas legais (/privacidade, /termos):
 * - destaca a seção visível no momento (scroll-spy);
 * - no desktop o sumário fica sempre aberto; no celular começa recolhido e
 *   fecha ao escolher uma seção.
 */
const sumario = document.querySelector<HTMLDetailsElement>('.legal__sumario');

if (sumario) {
    const mobile = window.matchMedia('(max-width: 1023px)');
    const links = Array.from(sumario.querySelectorAll<HTMLAnchorElement>('.legal__sumario-link'));

    const sincronizarAbertura = () => {
        sumario.open = !mobile.matches;
    };
    sincronizarAbertura();
    mobile.addEventListener('change', sincronizarAbertura);

    sumario.querySelector('summary')?.addEventListener('click', (e) => {
        if (!mobile.matches) e.preventDefault();
    });

    links.forEach((link) => {
        link.addEventListener('click', () => {
            if (mobile.matches) sumario.open = false;
        });
    });

    const ativar = (id: string) => {
        links.forEach((link) => {
            link.classList.toggle('legal__sumario-link--ativo', link.hash === `#${id}`);
        });
    };

    const secoes = links
        .map((link) => document.getElementById(decodeURIComponent(link.hash.slice(1))))
        .filter((el): el is HTMLElement => el !== null);

    if ('IntersectionObserver' in window && secoes.length) {
        const visiveis = new Set<string>();
        const observer = new IntersectionObserver(
            (entradas) => {
                entradas.forEach((entrada) => {
                    if (entrada.isIntersecting) visiveis.add(entrada.target.id);
                    else visiveis.delete(entrada.target.id);
                });
                const atual = secoes.find((secao) => visiveis.has(secao.id));
                if (atual) ativar(atual.id);
            },
            // Faixa superior da tela: a seção "atual" é a cujo título passou por ali.
            { rootMargin: '0px 0px -70% 0px' },
        );
        secoes.forEach((secao) => observer.observe(secao));
    }
}
